import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService, UserRole } from 'services/account.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerPortalGuard implements CanActivate {
  private accountService = inject(AccountService);
  private router = inject(Router);

  public canActivate(): boolean {
    if (this.accountService.userRole === UserRole.MSP) {
      return true;
    } else {
      this.router.navigate(['']);
    }

    return false;
  }
}
